import api from '../../../services/Api';
import { IEmpresaQsaItem, IEmpresaQsaLista, IEmpresaQsaSalvar } from '../interfaces/IEmpresaQsa';

export const QsaService = {
  async listar(empresaId: number): Promise<IEmpresaQsaLista> {
    const response = await api.get<IEmpresaQsaLista>(`empresa/${empresaId}/qsa`);
    return response.data;
  },

  async adicionar(empresaId: number, socio: IEmpresaQsaSalvar): Promise<{ id: number }> {
    const response = await api.post<{ id: number }>(`empresa/${empresaId}/qsa`, socio);
    return response.data;
  },

  async atualizar(empresaId: number, socioId: number, socio: IEmpresaQsaSalvar): Promise<void> {
    await api.put(`empresa/${empresaId}/qsa/${socioId}`, socio);
  },

  async remover(empresaId: number, socioId: number): Promise<void> {
    await api.delete(`empresa/${empresaId}/qsa/${socioId}`);
  },

  async sincronizar(empresaId: number): Promise<{ sucesso: boolean; mensagem: string; mensagemTecnica?: string; socios: IEmpresaQsaItem[] }> {
    const response = await api.post<{ sucesso: boolean; mensagem: string; mensagemTecnica?: string; socios: IEmpresaQsaItem[] }>(
      `empresa/${empresaId}/qsa/sincronizar`
    );
    return response.data;
  },
};
